import { Text } from "@avanadeits/vangogh";

import AvanadeAccountRequest from "./AvanadeAccountRequest";
import AvanadeGuestRequest from "./AvanadeGuestRequest";
import AvanadeMailboxRequest from "./AvanadeMailboxRequest";
import OnPremiseAccountRequest from "./OnPremiseAccountRequest";
import { useEffect, useState } from "react";
import requestCommonService from "../../../services/requestCommonService";

type AccountRequestListProps = {
  avanadeGuestAccountInUse: boolean;
};

type RequestedAccountType = {
  Avanade: boolean,
  Mailbox: boolean,
  OnPrem: boolean
}

const initialState = {
  Avanade: false,
  Mailbox: false,
  OnPrem: false
}

const AccountRequestList = (props: AccountRequestListProps) => {
  const [isAccountRequested, setIsAccountRequested] = useState<RequestedAccountType>(initialState)

  const getRequestedAccount = async () => {
    const response = await requestCommonService.getUserRequestedAccounts()
    const accountRequested: RequestedAccountType = { ...initialState }
    Object.keys(isAccountRequested).forEach(item => {
      const key = item as keyof RequestedAccountType
      accountRequested[key] = item === response
    })
    setIsAccountRequested(accountRequested)
  }
  
  useEffect(() => {
    getRequestedAccount()
  }, [])

  const requestedAnotherAccount = Object.values(isAccountRequested).includes(true);
  return (
    <>
      <Text className="IP-bd__label">
        <b>Request</b> for accounts in <b>Avanade</b> environment:
      </Text>
      <div className="IP-cardList">
        <AvanadeMailboxRequest isAccountRequested={isAccountRequested.Mailbox} requestedAnotherAccount={requestedAnotherAccount} />
        <AvanadeAccountRequest isAccountRequested={isAccountRequested.Avanade} requestedAnotherAccount={requestedAnotherAccount} />
        <AvanadeGuestRequest disabled={props.avanadeGuestAccountInUse} />
      </div>
    </>
  );
};

export default AccountRequestList;
